var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingReceived(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#DC4405",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.677 28.776H15.64C12.856 28.776 11 27.384 11 24.136V17.64C11 14.392 12.856 13 15.64 13H24.92C27.704 13 29.56 14.392 29.56 17.64V21.7",
    stroke: "#DC4405",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9206 18.1035L22.0206 20.4235C21.5162 20.7942 20.9066 20.9942 20.2806 20.9942C19.6546 20.9942 19.045 20.7942 18.5406 20.4235L15.6406 18.1035",
    stroke: "#DC4405",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0664 30.5352C30.9994 30.5352 32.5664 28.9682 32.5664 27.0352C32.5664 25.1022 30.9994 23.5352 29.0664 23.5352C27.1334 23.5352 25.5664 25.1022 25.5664 27.0352C25.5664 28.9682 27.1334 30.5352 29.0664 30.5352Z",
    fill: "#DC4405"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 25.7236V28.2656",
    stroke: "#FCEDE6",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.752 27.0787L29.064 28.3477L30.376 27.0787",
    stroke: "#FCEDE6",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingReceived);
export default __webpack_public_path__ + "static/media/pending-received.5809aba0ad0b1a56f59e0c1e470a5624.svg";
export { ForwardRef as ReactComponent };